import { useEffect, useState } from "react";
import { getUserPosts } from "../APIs/postApi";

export const useProfilePosts = (userId) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) { setLoading(false); return; }
    const fetchPosts = async () => {
      try {
        const data = await getUserPosts(userId);
        setPosts(Array.isArray(data) ? data : data.results || []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, [userId]);

  return { posts, loading, error };
};